import { IAlumniCompanies } from '@/interfaces/categoryPage';
import { companyImage } from '@/utils/common/env.constants';
import React from 'react';

const CompanyCard = (props: IAlumniCompanies) => {
  const { _id, companyLogoFileName } = props;

  return (
    <div
      className="bg-[#fff] rounded w-[154px] medium:w-[158px] flex flex-row items-center justify-center px-9 py-3"
      key={_id}
    >
      <img
        src={`${companyImage}/company_logos/${companyLogoFileName}`}
        height={30}
        width={80}
        alt="name-logo"
        className="h-[30px]"
      />
    </div>
  );
};

export default CompanyCard;
